/**
 * Created by Mike Naughton on 7/6/17.
 *
 * Shim for backbone to make sure we attach all the important stuff to the jquery used by backbone
 */

var Backbone = require("../../../node_modules/backbone/backbone");
var jQueryBootstrap = require("bootstrap");

require("jquery.scrollto");
require("jquery-form/jquery.form.js");
require("bootstrap-colorpicker");
require("bootstrap-notify");
require("bootstrap-slider");
require("bootstrap-3-typeahead");
require("jstree");

Backbone.$ = jQueryBootstrap;

module.exports = Backbone;



//////////////////
// WEBPACK FOOTER
// ./public/lib/js/backbone-shim.js
// module id = 3
// module chunks = 4